
import * as moment from "moment";

export default {
  	init() {
	  	var mapInitialized = false;
		$('.results').on('click', 'button.transfer-button', function() {
			$(this).toggleClass('open');
			$(this).parents('tr').next('tr.transfer-row').slideToggle().siblings('.transfer-row').slideUp();
		});

		$('#stop-info').waypoint({
			handler: function() {
				if (!mapInitialized) {
					initMap();
					mapInitialized = true;
				}
			},
			offset: '110%',
		});

		$("#schedule .load").on("click", function(e) {
			e.preventDefault();

			var stop = parseInt($('#schedule').data('stop'));
			var date = $('#schedule').data('date');
			var time = $('#schedule').data('time');
			var offset = parseInt($(this).attr("data-offset"));

			$.ajax({
				url: ajaxurl,
				method: "POST",
				data: {
					action: "get_more_upcoming",
					stop: stop,
					date: date,
					offset: offset,
					count: 10,
					time: time
				},
				success: function(data) {
					var content = "";
					var d = JSON.parse(data);
					$(".results table tbody").html("");
					var t;
					var item;
					if (d) {
						for (var routedate in d) {
							t = moment(routedate);
							content += "<tr><th colspan='3'>"+t.format('MMMM D, YYYY')+"</th></tr>";
							for (var i in d[routedate]) {
								item = d[routedate][i];
								content +=
									"<tr><td>" +
									item.departure_time +
									"</td><td>to " +
									item.arrival_dock +
                					(item.transfer_dock !== false ? "<button type='button' class='transfer-button'><i class='fas fa-chevron-down'></i><span class='sr-only'>See Transfer</span></button>" : "") +
									"</td><td>Arrives " +
									item.arrival_time +
									"</td></tr>";
								if (item.transfer_dock !== false) {
									content += 
									"<tr class='transfer-row'><td colspan='3'>" +
									"<div class='row'>"+
									"<span class='dock'>"+item.departure_dock+"</span>"  +
									"<span class='time'>Depart "+item.departure_time+"</span>"+
									"</div>" +
									"<div class='row'>"+
									"<span class='dock'>"+item.transfer_dock.post_title+"</span>"+
									"<span class='time'>Arrive "+item.transfer_time+"</span>"+
									"</div>"+
									"<div class='transfer'>Transfer</div>"+
									"<div class='row'>"+
									"<span class='dock'>"+item.transfer_dock.post_title+"</span>"+
									"<span class='time'>Depart "+item.transfer_departure+"</span>"+
									"</div>"+
									"<div class='row'>"+
									"<span class='dock'>"+item.arrival_name+"</span>"+
									"<span class='time'>Arrive "+item.arrival_time+"</span>"+
									"</div>"+
									"</td></tr>";
								}
							}
						}
						var nextOffset = offset + 10;
						var prevOffset = offset - 10;
						$("#load-back").attr("data-offset", prevOffset);
						$("#load-forward").attr("data-offset", nextOffset);
						$(".results #load-forward").show();
						if (prevOffset < 0) {
							$(".results #load-back").hide();
						} else {
							$(".results #load-back").show();
						}
					} else {
						if (offset <= 0) {
							$(".results #load-back").hide();
						}
						if (offset > 0) {
							$('.results #load-forward').hide();
						}
						content = "<tr><td colspan='3' style='text-align: center'>No further results.</td></tr>";
					}
					$(".results table tbody").html(content);
					$(".results table").show();
				}
			});
		});
  	}
};



// WEBPACK FOOTER //
// ./scripts/routes/stop.js